import React, { useState, useMemo, useEffect } from 'react';
import LayoutMain from "../LayoutMain/LayoutMain";
import Mileagesaarathi_two from './MileageSaarathiTab_ace/MileageSaarathiTab'; // Import the new component
import styles from "./MileageSarathi_ace.module.css";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import MileageAnalysisTab from './MileageAnalysisTab_ace/MileageAnalysisTab';
import Overview from './Overview_Tab_ace/Overview';
import GrowthTrackingTab from './GrowthTrackingTab_ace/GrowthTracking';
import './style.css';
import { VehicleDataProvider } from './MileageAnalysisTab_ace/context';
import MileageSimulatorTab from './MileageSimulatorTab/MileageSimulatorTab';
import RangeAnalysisTab from './RangeAnalysisTab_ace/RangeAnalysisTab_ace';
import { RangeAnalysisProvider } from './RangeAnalysisTab_ace/Context';
import { MultivarientProvider } from './MultivariateAnalysisTab_ace/context';
import MultivariateAnalysisTab from './MultivariateAnalysisTab_ace/MultivariateAnalysisTab';

function Mileagesaarathi_ace() {
  const [activeTab, setActiveTab] = useState('Overview'); // Overview as default
  const { isLoading, error, sendReq: fetchData } = useHttp();

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "Mileage Saarathi Ace"
      }
    })
  }, [])

  const tabs = [
    'Overview',
    'Mileage Saarathi',
    'Mileage Analysis',
    'Range Analysis',
    'Growth Tracking',
    'Mileage Simulator',
    'MS - Multivariate Analysis'
  ];

  return (
    <LayoutMain>
      <div className={`${styles.bg_screen}`}>
        <div className={`mb-3 card ${styles.bg_screen2}`}>
          <div className="col-12">
            <div className={`nav ${styles.tabs}`}>
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`${styles.nav_bar_buttons} ${activeTab === tab ? styles.tab_bar : ''}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>

        {activeTab === 'Overview' && <Overview />}
        {activeTab === 'Mileage Saarathi' && <Mileagesaarathi_two />}
        {activeTab === 'Mileage Analysis' && (
          <VehicleDataProvider>
            <MileageAnalysisTab />
          </VehicleDataProvider>
        )}
        {activeTab === 'Range Analysis' && (
          // <></>
          <RangeAnalysisProvider>
            <RangeAnalysisTab />
          </RangeAnalysisProvider>
        )}
        {activeTab === 'Growth Tracking' && <GrowthTrackingTab />}
        {activeTab === 'Mileage Simulator' && <MileageSimulatorTab />}
        {activeTab === 'MS - Multivariate Analysis' && (
          <MultivarientProvider>
            <MultivariateAnalysisTab />
          </MultivarientProvider>
        )}
      </div>
    </LayoutMain>
  );
}

export default Mileagesaarathi_ace;
